import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import DocumentTitle from 'react-document-title'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import { acknowledgePerformance, loadPerformancePage } from 'actions/performance'
import { draftDealsCancel, draftDealsEdit, draftDealsSave, draftDealsUpdateField } from 'actions/draft-deals'
import {
  getAttendeeList,
  getPerformanceCalloverList,
  getPerformanceInfo,
  getPerformanceMarket,
  getUngroupedPerformanceDeals,
  isEditable,
  isSaving,
} from 'selectors/performance'
import { getCurrentPartner, getFeatureFlag } from 'selectors/settings'
import { formatDateTimeNice } from 'utils/datetime'
import { getHistoryUrl, getPartnerUrl } from 'utils/urls'
import Loader from 'components/loader'
import DealListHeader from 'components/deal-list-header'
import DealList from 'components/deal-list'
import AttendeeHeader from 'components/attendee-header'
import AttendeeList from 'components/attendee-list'
import AccessControl from 'components/access-control'
import errorHandler from 'components/error-handler'
import EventHeader from 'components/event-header'

import styles from './performance-page.css'

class PerformancePage extends Component {

  constructor(props) {
    super(props)

    this.onUpdateValue = this.onUpdateValue.bind(this)
    this.onChangeMode = this.onChangeMode.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onDownload = this.onDownload.bind(this)
    this.onPrint = this.onPrint.bind(this)
  }

  componentWillMount() {
    this.props.loadPerformancePage(this.props.performanceId)

    if (this.props.ack !== undefined) {
      this.props.acknowledgePerformance(this.props.performanceId)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.performanceId !== nextProps.performanceId) {
      this.props.loadPerformancePage(nextProps.performanceId)
    }
  }

  componentWillUnmount() {
    if (this.props.editable) {
      this.props.draftDealsCancel()
    }
  }

  onChangeMode() {
    if (this.props.editable) {
      this.props.draftDealsCancel()
    } else {
      this.props.draftDealsEdit(this.props.ungroupedDeals)
    }
  }

  onSave() {
    this.props.draftDealsSave()
  }

  onUpdateValue(dealId, field, value) {
    if (field === 'isOnsale' && !this.props.editable) {
      this.onChangeMode()
    }
    this.props.draftDealsUpdateField(dealId, { [field]: value })
  }

  onDownload() {
    this.props.acknowledgePerformance(this.props.performanceId)

    location.href = getPartnerUrl(this.props.partnerId, `/performance/${this.props.performanceId}/attendees/export`)
  }

  onPrint() {
    this.props.acknowledgePerformance(this.props.performanceId, true)

    window.print()
  }

  render() {
    const {
      performance,
      groupedTickets,
      ungroupedTickets,
      attendeeList,
      canSeeCustomerData,
      currencyCode,
      partnerId,
      showSummaryLink,
    } = this.props
    const hasAttendees = attendeeList && attendeeList.length > 0

    if (!performance || !performance.eventGroup || !performance.venue || !groupedTickets || !ungroupedTickets) {
      return (
        <div styleName="centered">
          <Loader center />
        </div>
      )
    }

    return (
      <DocumentTitle title="Ecommerce Portal - Time Out - Performance Page">
        <div styleName="page">
          <EventHeader
            showBottomBar
            addNewDatesUrl={performance.eventGroup.addNewDatesUrl}
            currencyCode={currencyCode}
            eventGroupId={performance.eventGroup.id}
            partnerId={partnerId}
            showSummaryLink={showSummaryLink}
            soldTickets={performance.soldTickets}
            subtitle={formatDateTimeNice(performance.startTime)}
            title={performance.eventGroup.name}
            totalPartnerShare={performance.totalPartnerShare}
            whitelabelUrl={performance.eventGroup.whitelabelUrl}
          />

          <div styleName="content">
            <RelayoutWrapper from="md">
              <Relayout align="center">
                <RelayoutItem xl="10">
                  <DealListHeader
                    editable={this.props.editable}
                    historyLink={this.props.historyLink}
                    onChangeMode={this.onChangeMode}
                    onHistory={this.onHistory}
                    onSave={this.onSave}
                    saving={this.props.saving}
                  />
                  <DealList
                    currencyCode={currencyCode}
                    deals={performance.deals}
                    editable={this.props.editable}
                    saving={this.props.saving}
                    onChange={this.onUpdateValue}
                  />

                  <AttendeeHeader
                    hasAttendees={hasAttendees}
                    onDownload={this.onDownload}
                    onPrint={this.onPrint}
                  />
                  <AccessControl
                    accessToken={performance.barcodeAccessToken}
                    qrUrl={performance.barcodeAccessTokenUrl}
                  />
                  {hasAttendees ?
                    <AttendeeList attendees={attendeeList} showCustomerData={canSeeCustomerData} />
                  :
                    null
                  }

                </RelayoutItem>
              </Relayout>
            </RelayoutWrapper>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

PerformancePage.propTypes = {
  ack: PropTypes.string,
  acknowledgePerformance: PropTypes.func,
  attendeeList: PropTypes.array,
  canSeeCustomerData: PropTypes.bool,
  currencyCode: PropTypes.string,
  draftDealsCancel: PropTypes.func,
  draftDealsEdit: PropTypes.func,
  draftDealsSave: PropTypes.func,
  draftDealsUpdateField: PropTypes.func,
  editable: PropTypes.bool,
  groupedTickets: PropTypes.array,
  historyLink: PropTypes.string,
  loadPerformancePage: PropTypes.func,
  partnerId: PropTypes.string,
  performance: PropTypes.object,
  performanceId: PropTypes.string,
  saving: PropTypes.bool,
  showSummaryLink: PropTypes.bool,
  ungroupedDeals: PropTypes.object,
  ungroupedTickets: PropTypes.array,
}

const mapStateToProps = (state, ownProps) => {
  const { performanceId, partnerId } = ownProps.params
  const { ack } = ownProps.location.query

  const performanceLoaded = state.entities.performances[performanceId]
  const performance = performanceLoaded ? getPerformanceInfo(performanceId)(state) : null
  const { groupedTickets, ungroupedTickets } = performanceLoaded ? getPerformanceCalloverList(performanceId)(state) : {}

  const market = performanceLoaded ? getPerformanceMarket(performanceId)(state) : null
  const currencyCode = market ? market.currency.code : null

  const currentPartner = getCurrentPartner(state)
  const canSeeCustomerData = currentPartner ? currentPartner.canSeeCustomerData : false

  const editable = isEditable(state)
  const ungroupedDeals = getUngroupedPerformanceDeals(performanceId)(state)
  const attendeeList = performanceLoaded ? getAttendeeList(performanceId)(state) : null
  const saving = isSaving(state)

  const firstDealId = performance && performance.deals ? performance.deals[0].id : null
  const historyLink = getHistoryUrl(partnerId, firstDealId)

  const eventGroupLink = performanceLoaded && performance.eventGroup ?
    getPartnerUrl(partnerId, `/event/${performance.eventGroup.id}`) : null

  const showSummaryLink = getFeatureFlag('portal_event_group_summary')(state)

  return {
    ack,
    attendeeList,
    canSeeCustomerData,
    currencyCode,
    editable,
    eventGroupLink,
    groupedTickets,
    historyLink,
    partnerId,
    performance,
    performanceId,
    saving,
    showSummaryLink,
    ungroupedDeals,
    ungroupedTickets,
  }
}

const mapDispatchToProps = {
  acknowledgePerformance,
  draftDealsCancel,
  draftDealsEdit,
  draftDealsSave,
  draftDealsUpdateField,
  loadPerformancePage,
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(errorHandler(PerformancePage), styles))



/** WEBPACK FOOTER **
 ** ./src/containers/performance-page/performance-page.js
 **/